<nav class="scrollbar-hover grow overflow-auto px-6 mb:mt-2" aria-labelledby="nav">
    <ul>
        <li
            *ngFor="let item of menuItems | async; index as i; trackBy: trackParentByName"
            class="group/item relative cursor-pointer transition-all ease-in"
            cdkOverlayOrigin
            #trigger="cdkOverlayOrigin"
            (click)="handleShowChildren(item)"
            (keyup)="handleShowChildren(item)"
            tabindex="-1"
        >
            <a
                class="mb-2 flex cursor-pointer flex-row items-center rounded px-2 py-1 transition-colors ease-in hover:bg-primary-100"
                (click)="handleExpandMenu(item)"
                [routerLink]="item.link ? [item.link] : null"
                routerLinkActive="bg-primary-100 text-primary-05"
                [ngClass]="{
                    '!bg-primary-100 !text-primary-05':
                        currentUrl.split('/').includes(item.name) &&
                        (!expanded() || expandedMenu !== item.name) &&
                        !item.link,
                }"
            >
                <svg-icon
                    [ngClass]="{
                        'ml-1 transition-[margin-left]': !expanded(),
                    }"
                    [src]="item.icon"
                ></svg-icon>

                <span
                    class="ml-2 grow overflow-hidden whitespace-nowrap text-sm font-semibold text-primary-05"
                    [ngClass]="{ hidden: !expanded() }"
                >
                    {{ item.title | translate }}
                </span>
                <svg-icon
                    *ngIf="item.children?.length"
                    svgClass="size-4"
                    class="transition-all duration-[0.15s] ease-in"
                    [ngClass]="{ hidden: !expanded(), 'rotate-90': expandedMenu === item.name }"
                    src="/assets/icons/chevron-right.svg"
                />
            </a>
            <ul
                *ngIf="item.children?.length && expanded()"
                class="overflow-hidden"
                [@expandCollapse]="expandedMenu === item.name ? 'expanded' : 'collapsed'"
            >
                <li
                    *ngFor="let child of item.children; trackBy: trackChildByLink"
                    class="mb-2 flex"
                >
                    <a
                        class="w-full cursor-pointer overflow-hidden whitespace-nowrap rounded px-2 py-1 pl-10 text-sm font-normal text-neutral-06 transition-colors ease-in hover:bg-primary-100 hover:text-primary-05"
                        [routerLink]="child.link"
                        [routerLinkActive]="['bg-primary-100', 'text-primary-05']"
                        [replaceUrl]="child.link"
                    >
                        {{ child.title | translate }}
                    </a>
                </li>
            </ul>
            <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayPositions]="cdkConnectedOverlayPositions"
                [cdkConnectedOverlayOpen]="!overlayVisible() && item.name === showPopoverChildren"
                (overlayOutsideClick)="!overlayVisible() && backdropClick()"
            >
                <div class="shadow-menuitem">
                    <ul class="relative rounded-lg bg-neutral-01 p-[10px]" *ngIf="!expanded()">
                        <li *ngFor="let child of item.children" class="mb-1 flex cursor-pointer">
                            <a
                                class="w-full whitespace-nowrap rounded-[4px] px-2 py-1 text-sm text-neutral-06 hover:bg-primary-100 focus:bg-primary-200"
                                (click)="showPopoverChildren = null"
                                [routerLink]="child.link"
                                routerLinkActive="bg-primary-100"
                            >
                                {{ child.title | translate }}
                            </a>
                        </li>
                        <span
                            class="menu-triangle absolute -left-[5px] top-[9.7px] h-3 w-2 bg-neutral-01"
                        ></span>
                    </ul>
                </div>
            </ng-template>
        </li>
    </ul>
</nav>
